@if (!isEditingDetail() && !isLoadingClaim) {
  <div class="mb-3 mt-1 mt-md-2 mb-md-4">
    <app-timeline [steps]="steps" [currentStep]="currentStepIndex" [allowAllSteps]="!!createdClaim || !!activeRequest" (stepChange)="onTimelineStepClick($event)"></app-timeline>
  </div>
}

<div class="panel mb-4"
     [class.panel-claim-mobile]="appSettings.isMobile() && claimStep === STEP_CLAIM && !isEditingDetail()"
     [class.panel-detail-open]="isEditingDetail()">
  @if (!isEditingDetail() && !appSettings.isMobile()) {
    <div class="step-header d-flex align-items-center justify-content-between gap-3">
      <h5 class="mb-0 text-dark fw-bold text-nowrap">
        @if (claimStep === STEP_PARTY) {
          <i class="fas fa-user me-2 text-primary"></i>Datos del socio y tipo de siniestro
        }
        @if (claimStep === STEP_THIRD_PARTY) {
          <i class="fas fa-user-injured me-2 text-warning"></i>Información del Tercero Afectado
        }
        @if (claimStep === STEP_CLAIM) {
          <i class="fas fa-car-burst me-2 text-primary"></i>Siniestro{{ claimTypeLabel ? ' - ' + claimTypeLabel : '' }}
        }
      </h5>
      @if (!isEditableClaim && createdClaim?.statusSlug) {
        <app-flow-badge
          display="badge"
          [processSlug]="claimForm?.get('claimType')?.value || createdClaim?.claimType"
          [statusSlug]="createdClaim?.statusSlug">
        </app-flow-badge>
      }
    </div>
  }

  @if (isLoadingClaim) {
    <div class="step-body text-center text-muted py-5">
      <div class="spinner-border spinner-border-sm me-2"></div>
      Cargando siniestro...
    </div>
  }

  @if (!isLoadingClaim && claimStep === STEP_PARTY) {
    <div class="step-body">
      <form [formGroup]="claimForm">
        @if (partyInput()) {
          <div class="mb-4">
            <app-party-form [partyForm]="partyForm" [mode]="formMode.VIEW"></app-party-form>
          </div>
        }

        <div class="row g-3 mb-3">
          <div class="col-12 col-md-6">
            <label class="form-label">Tipo de Siniestro</label>
            <app-sheet-select
              [items]="claimTypes"
              bindLabel="name"
              bindValue="id"
              title="Tipo de Siniestro"
              placeholder="Seleccione tipo de siniestro..."
              formControlName="claimType"
              [clearable]="false"
              [searchable]="false">
            </app-sheet-select>
          </div>

          @if (claimForm?.get('claimType')?.value) {
            <div class="col-12 col-md-6">
              <label class="form-label">Vehículo del Socio</label>
              <app-sheet-select
                [items]="vehicleSelectItems"
                bindLabel="selectLabel"
                bindValue="uuid"
                title="Vehículo del Socio"
                placeholder="Seleccione un vehículo..."
                formControlName="vehicleId"
                [clearable]="false"
                [searchable]="vehicleSelectItems.length > 5">
              </app-sheet-select>
            </div>
          }
        </div>
      </form>
    </div>
  }

  @if (!isLoadingClaim && claimStep === STEP_THIRD_PARTY) {
    <div class="step-body">
      <form [formGroup]="claimForm">
        <app-third-party-form
          [thirdPartyForm]="claimForm"
          [brands]="thirdPartyBrands"
          [allModels]="allModels"
          [mode]="isEditableClaim ? formMode.CREATE : formMode.VIEW">
        </app-third-party-form>
      </form>
    </div>
  }

  @if (!isLoadingClaim && claimStep === STEP_CLAIM) {
    <div class="step-body">
      @if (!isEditingDetail() && claimDetails.length > 0 && !allDetailsFinalized()) {
        <div class="alert alert-info py-2 px-3 mb-3" style="font-size: 13.5px;">
          <div class="d-flex align-items-start gap-2 mb-2">
            <i class="fas fa-info-circle text-primary mt-1"></i>
                <p class="text-muted small mb-2">Finalice {{ pendingDetailsCount() }} daño(s) pendiente(s) cargando evidencias antes de <strong>enviar la solicitud</strong>.</p>
          </div>
          <ul class="mb-0 ps-4">
            @for (det of claimDetails; track $index) {
              <li>
                {{ det.geographicLocation || det.damageDescription || ('Daño ' + ($index + 1)) }}
                — <span class="fw-semibold">{{ getDetailProgress(det).label }}</span>
              </li>
            }
          </ul>
        </div>
      }

      <app-claim-details-manager
        [claimForm]="claimForm"
        [claimData]="createdClaim"
        [partyData]="partyInput()"
        [vehicleData]="vehiclesInput() ?? []"
        [claimTypes]="claimTypes"
        [(selectedVehicleType)]="selectedVehicleType"
        [initialAffectedParts]="partsSelected"
        [(claimDetails)]="claimDetails"
        [(isEditingDetail)]="isEditingDetail"
        [(selectedDetailView)]="selectedDetailView"
        (claimDetailsChange)="onDetailsChanged($event)"
        [mode]="isEditableClaim ? formMode.EDIT : formMode.VIEW"
        (partsSelected)="onClaimPartsSelected($event)"
        (documentUploaded)="refreshClaimData()"
        (headerEditorActionChange)="headerEditorActionChange.emit($event)">
      </app-claim-details-manager>
    </div>
  }

  @if (!isEditingDetail() && !isLoadingClaim && !appSettings.isMobile()) {
    <div class="step-footer" [class.step-footer--bpm]="showClaimBpmDesktop">
      <div>
        @if (claimStep === STEP_PARTY || claimStep === STEP_CLAIM) {
          <button class="btn btn-outline-danger btn-sm px-3" (click)="onClose.emit(true)">
            <i class="fas fa-times me-2"></i> {{ isEditableClaim ? 'Cancelar' : 'Cerrar' }}
          </button>
        }
        @if (claimStep === STEP_THIRD_PARTY) {
          <button class="btn btn-outline-secondary btn-sm px-3" (click)="prevClaimStep()">
            <i class="fas fa-arrow-left me-2"></i> Anterior
          </button>
        }
      </div>
      <div class="d-flex flex-wrap align-items-center justify-content-end gap-2">
        @if (isEditableClaim && isDraftRequest && activeRequest && !showClaimBpmDesktop) {
          <button class="btn btn-outline-danger btn-sm px-3" (click)="deleteRequestApproval()" [disabled]="isSaving()">
            <i class="fas fa-trash-alt me-1"></i> Desechar borrador
          </button>
        }
        @if (claimStep === STEP_PARTY || claimStep === STEP_THIRD_PARTY) {
          <button class="btn btn-primary btn-sm px-3" (click)="nextClaimStep()">
            Siguiente <i class="fas fa-arrow-right ms-2"></i>
          </button>
        }
        @if (showClaimBpmDesktop) {
          <app-bpm
            class="step-footer__bpm"
            [request]="activeRequest"
            [isProcessing]="isSaving()"
            [showReject]="false"
            [allowDraftSubmit]="true"
            [showDelete]="true"
            [blockedReason]="bpmBlockedReason"
            (approve)="onBpmApprove()"
            (deleteRequest)="deleteRequestApproval()"
            (confirmed)="onBpmConfirmed($event)">
          </app-bpm>
        } @else if (claimStep === STEP_CLAIM && claimDetails.length > 0 && isEditableClaim && !activeRequest) {
          <span [attr.title]="submitBlockedReason() || null">
            <button class="btn btn-success btn-sm px-4" [disabled]="!allDetailsFinalized() || isSaving()" (click)="submitClaimDocuments()">
              @if (isSaving()) {
                <span class="spinner-border spinner-border-sm me-2"></span> Procesando...
              } @else {
                <i class="fas fa-check-circle me-2"></i> Enviar solicitud de siniestro
              }
            </button>
          </span>
        }
      </div>
    </div>
  }

  @if (!isEditingDetail() && !isLoadingClaim && showClaimBpmMobile) {
    <app-bpm
      [request]="activeRequest"
      [isProcessing]="isSaving()"
      [showReject]="false"
      [allowDraftSubmit]="true"
      [showDelete]="false"
      [blockedReason]="bpmBlockedReason"
      [hideButtons]="true"
      (approve)="onBpmApprove()"
      (confirmed)="onBpmConfirmed($event)">
    </app-bpm>
  }
</div>

<app-mobile-footer [visible]="!!headerWizardAction() || canSubmitClaimFromFooter() || canRegisterDamage() || canDeleteFromHeader()">
  @if (canDeleteFromHeader()) {
    <button type="button" class="btn btn-outline-danger btn-sm"
      [disabled]="isSaving()"
      (click)="deleteFromHeader()">
      <i class="fas fa-trash-alt me-1"></i>Desechar
    </button>
  }
  @if (headerWizardAction(); as action) {
    @if (isEditingDetail() && action === 'finalize') {
      <button type="button" class="btn btn-primary btn-sm"
        [disabled]="isEditorSaving()"
        (click)="saveDetailDraftFromHeader()">
        @if (isEditorSaving()) {
          <span class="spinner-border spinner-border-sm me-1"></span>
        }
        Guardar
      </button>
      <button type="button" class="btn btn-success btn-sm"
        [disabled]="isEditorSaving()"
        (click)="saveEditorFromHeader()">
        Dejar en revisión
      </button>
    } @else {
      <button type="button" class="btn btn-sm"
        [class.btn-success]="action === 'finalize'"
        [class.btn-primary]="action !== 'finalize'"
        [disabled]="isEditorSaving()"
        (click)="saveEditorFromHeader()">
        @if (isEditorSaving()) {
          <span class="spinner-border spinner-border-sm me-1"></span>
        }
        @if (action === 'finalize') {
          Dejar en revisión
        } @else if (action === 'next') {
          Siguiente
        } @else {
          Guardar
        }
      </button>
    }
  } @else {
    @if (canRegisterDamage()) {
      <button type="button" class="btn btn-sm"
        [class.btn-primary]="!canSubmitClaimFromFooter()"
        [class.btn-outline-primary]="canSubmitClaimFromFooter()"
        (click)="registerDamageFromFooter()">
        <i class="fas fa-plus me-1"></i>Registrar daño
      </button>
    }
    @if (canSubmitClaimFromFooter()) {
      <span class="d-inline-flex flex-grow-1" [attr.title]="submitBlockedReason() || null">
        <button type="button" class="btn btn-success btn-sm w-100"
          [disabled]="!allDetailsFinalized() || isSaving()"
          (click)="submitClaimDocuments()">
          @if (isSaving()) {
            <span class="spinner-border spinner-border-sm me-1"></span>
          }
          Enviar
        </button>
      </span>
    }
  }
</app-mobile-footer>
